import { avvocatiSolution } from './avvocati';
import { commercialistiSolution } from './commercialisti';
import { consulentiDelLavoroSolution } from './consulenti-del-lavoro';
import { studiLegaliSolution } from './studi-legali';
import { aziendeSolution } from './aziende';
import type { SolutionContent } from './types';

/** Registry delle pagine soluzioni, nell'ordine di menu e indice */
export const SOLUTIONS: SolutionContent[] = [
  avvocatiSolution,
  commercialistiSolution,
  consulentiDelLavoroSolution,
  studiLegaliSolution,
  aziendeSolution,
];

export function getSolution(slug: string): SolutionContent {
  const solution = SOLUTIONS.find(s => s.slug === slug);
  if (!solution) throw new Error(`Soluzione non trovata: ${slug}`);
  return solution;
}
